<header [class.scrolled]="scrolled()">
  <div class="wrap nav">
    <a href="#" class="logo">
      <img
        loading="lazy"
        style="height: 48px"
        height="48"
        src="assets/logo/logo.webp"
        alt=""
      />
      ConnectNow
    </a>
    <ul class="nav-links mb-0">
      <li><a href="#hero">Home</a></li>
      <li><a href="#how">Features</a></li>
      <li><a href="#benefits">Benefits</a></li>
      <li><a href="#industry">Industry</a></li>
      <li><a href="#assistant">Assistant</a></li>
      <li><a href="#footer">Contact</a></li>
      <li><a href="https://help.connectnow.ai">Help</a></li>
    </ul>
    <div class="nav-cta">
      <a
        href="https://dashboard.connectnow.ai/#/auth/login"
        class="btn btn-ghost"
        >Login</a
      >
      <!-- <a href="https://dashboard.connectnow.ai/#/auth/signup" class="btn btn-solid">Start Now
        <svg width="15" height="15" viewBox="0 0 24 24" fill="none"><path d="M5 12h14M13 6l6 6-6 6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>
      </a> -->
      <button class="menu-toggle" (click)="openMenu()" aria-label="Menu">
        <span></span><span></span><span></span>
      </button>
    </div>
  </div>
</header>

<div class="mobile-menu" [class.open]="menuOpen()">
  <button class="close" (click)="closeMenu()">&times;</button>
  <a href="#hero" (click)="closeMenu()">Home</a>
  <a href="#how" (click)="closeMenu()">Features</a>
  <a href="#benefits" (click)="closeMenu()">Benefits</a>
  <a href="#industry" (click)="closeMenu()">Industry</a>
  <a href="#assistant" (click)="closeMenu()">Assistant</a>
  <a href="#footer" (click)="closeMenu()">Contact</a>
  <a href="https://dashboard.connectnow.ai/#/auth/login" (click)="closeMenu()"
    >Login</a
  >
</div>
